import {
    useEffect,
    useState,
    useCallback
} from 'react';
import {
    Container,
    Content,
    InProgress
} from './styled';
import {
    FaEye,
    FaEyeSlash
} from "react-icons/fa";
import {
    IoMdCheckmarkCircleOutline
} from "react-icons/io";
import {
    IoAlertCircleOutline
} from "react-icons/io5";
import {
    resetPassword
} from '../../service/serviceChat/usersService';
import {
    useAuth
} from '../../contexts/auth';
import { toast } from 'react-toastify';
import Checked from '../../assets/gif/HLyS4muYKa.gif';

export function ResetPassword({ onBack }) {

    const { signOut } = useAuth();

    const [password, setPassword] = useState({
        current: '',
        new: '',
        confirm: ''
    });
    const [viewPassword, setViewPassword] = useState({
        current: false,
        new: false,
        confirm: false
    });
    const [recommendations, setRecommendations] = useState({
        has8Characters: false,
        has1UppercaseLetter: false,
        has1LowercaseLetter: false,
        has1Number: false,
        has1SpecialChars: false,
    });
    const [confirmPassword, setConfirmPassword] = useState(true);
    const [enabledBtnSave, setEnabledBtnSave] = useState(false);
    const [inProgress, setInprogress] = useState(false)

    const enabledSaved = useCallback(
        () => !!password.current && recommendations.has8Characters &&
            recommendations.has1UppercaseLetter && recommendations.has1LowercaseLetter &&
            recommendations.has1SpecialChars && recommendations.has1Number,
        [password, recommendations]
    );
    useEffect(() => {
        const validatePassword = () => {
            if (!password.confirm) {
                setConfirmPassword(true);
            } else {
                const confirmPasswordIsTrue = password.new === password.confirm;
                setConfirmPassword(confirmPasswordIsTrue);
                if (confirmPasswordIsTrue && enabledSaved()) {
                    setEnabledBtnSave(true);
                } else {
                    setEnabledBtnSave(false);
                }
            }
        };
        validatePassword();
    }, [password, enabledSaved]);

    useEffect(() => {
        if (inProgress === 2) {
            onWaitingTime(3000, () => {
                signOut();
            })
        }
    }, [inProgress])

    const verificationRecommendations = (str) => {
        const specialChars = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
        setRecommendations((prev) => ({
            ...prev,
            has8Characters: str.length >= 8,
            has1UppercaseLetter: Boolean(str.match(/[A-Z]/)),
            has1LowercaseLetter: Boolean(str.match(/[a-z]/)),
            has1Number: Boolean(str.match(/\d/)),
            has1SpecialChars: Boolean(str.match(specialChars)),
        }));
        return str
    };
    const onReset = () => {
        setPassword({
            current: '',
            new: '',
            confirm: ''
        });
        setViewPassword({
            current: false,
            new: false,
            confirm: false
        });
        setRecommendations({
            has8Characters: false,
            has1UppercaseLetter: false,
            has1LowercaseLetter: false,
            has1Number: false,
            has1SpecialChars: false,
            hasErrorInConfirmPassword: false
        });
        setEnabledBtnSave(false)
    };
    const handleClear = (e) => {
        e.preventDefault();
        onReset();
    };
    const handleCancel = (e) => {
        e.preventDefault();
        onReset();
        onBack();
    };

    const onWaitingTime = (time, callback) => {
        const timeoutId = setTimeout(() => {
            callback();
        }, time);
        return () => clearTimeout(timeoutId);
    };
    async function handleSave(e) {
        e.preventDefault();
        setInprogress(1);
        const solicitation = await resetPassword(password);
        onWaitingTime(2000, () => {
            if (solicitation?.status_code === 200) {
                setInprogress(2)
                toast.success(
                    `${solicitation?.message}`,
                    {
                        position: "top-center",
                        theme: "colored",
                    }
                );
            } else {
                toast.error(
                    `${solicitation?.message}`,
                    {
                        position: "top-center",
                        theme: "colored",
                    }
                );
                setInprogress(false);
            };
        });
    };

    return (
        <Container>
            <Content className={(inProgress) && 'hidden'}>
                <div>
                    <div>
                        <label htmlFor="current-password">
                            {`Senha atual`}
                        </label>
                        <input
                            type={(viewPassword.current) ? "text" : "password"}
                            placeholder="Digite a senha atual"
                            id="current-password"
                            name="current-password"
                            autoComplete="current-password"
                            value={password.current}
                            onChange={(e) => {
                                setPassword((prev) => ({
                                    ...prev,
                                    current: e.target.value.replace(/\s/g, ""),
                                }));
                            }}
                        />
                        <span onClick={() => {
                            setViewPassword((prev) => ({
                                ...prev,
                                current: !viewPassword?.current,
                            }));
                        }}>
                            {(!viewPassword.current)
                                ? (<FaEyeSlash />)
                                : (<FaEye />)
                            }
                        </span>
                    </div>
                    <div>
                        <label htmlFor="new-password">
                            {`Nova senha`}
                        </label>
                        <input
                            type={(viewPassword.new) ? "text" : "password"}
                            placeholder="Digite a nova senha"
                            id="new-password"
                            name="new-password"
                            autoComplete="new-password"
                            value={password.new}
                            onChange={(e) => {
                                setPassword((prev) => ({
                                    ...prev,
                                    new: verificationRecommendations(e.target.value.replace(/\s/g, "")),
                                }));
                            }}
                        />
                        <span onClick={() => {
                            setViewPassword((prev) => ({
                                ...prev,
                                new: !viewPassword.new,
                            }));
                        }}>
                            {(!viewPassword?.new)
                                ? (<FaEyeSlash />)
                                : (<FaEye />)
                            }
                        </span>
                    </div>
                    <div
                        className={
                            (!confirmPassword)
                                ? "error"
                                : ""
                        }
                    >
                        <label htmlFor="confirm-password">
                            {`Confirme a senha 
                            ${(!confirmPassword)
                                    ? '(a confirmação de senha não confere)'
                                    : ''
                                }
                        `}
                        </label>
                        <input
                            type={(viewPassword.confirm) ? "text" : "password"}
                            placeholder="Repita a nova senha"
                            id="confirm-password"
                            name="confirm-password"
                            autoComplete="new-password"
                            value={password.confirm}
                            onChange={(e) => {
                                setPassword((prev) => ({
                                    ...prev,
                                    confirm: e.target.value.replace(/\s/g, ""),
                                }));
                                setRecommendations((prev) => ({
                                    ...prev,
                                    hasErrorInConfirmPassword: password.new !== e.target.value.replace(/\s/g, ""),
                                }));
                            }}
                        />
                        <span onClick={() => {
                            setViewPassword((prev) => ({
                                ...prev,
                                confirm: !viewPassword.confirm,
                            }));
                        }}>
                            {(!viewPassword?.confirm)
                                ? (<FaEyeSlash />)
                                : (<FaEye />)
                            }
                        </span>
                    </div>
                </div>
                <div>
                    <span>
                        {`Sua senha deve conter:`}
                    </span>
                    <div className={(recommendations.has8Characters) ? "has" : ""}>
                        {(recommendations.has8Characters)
                            ? (<IoMdCheckmarkCircleOutline />)
                            : (<IoAlertCircleOutline />)
                        }
                        {`pelo menos 8 caracteres.`}
                    </div>
                    <div className={(recommendations.has1UppercaseLetter) ? "has" : ""}>
                        {(recommendations.has1UppercaseLetter)
                            ? (<IoMdCheckmarkCircleOutline />)
                            : (<IoAlertCircleOutline />)
                        }
                        {`pelo menos 1 letra maiúscula.`}
                    </div>
                    <div className={(recommendations.has1LowercaseLetter) ? "has" : ""}>
                        {(recommendations.has1LowercaseLetter)
                            ? (<IoMdCheckmarkCircleOutline />)
                            : (<IoAlertCircleOutline />)
                        }
                        {`pelo menos 1 letra minúscula.`}
                    </div>
                    <div className={(recommendations.has1Number) ? "has" : ""}>
                        {(recommendations.has1Number)
                            ? (<IoMdCheckmarkCircleOutline />)
                            : (<IoAlertCircleOutline />)
                        }
                        {`pelo menos 1 numero.`}
                    </div>
                    <div className={(recommendations.has1SpecialChars) ? "has" : ""}>
                        {(recommendations.has1SpecialChars)
                            ? (<IoMdCheckmarkCircleOutline />)
                            : (<IoAlertCircleOutline />)
                        }
                        {`pelo menos 1 simbolo. Ex [* ! # $ % & + – / : ; = ? @ |]`}
                    </div>
                </div>
                <div>
                    {(!password.current && !password.new && !password.confirm)
                        ? <button
                            className='cancel'
                            onClick={(e) => handleCancel(e)}
                        >
                            {`Cancelar`}
                        </button>
                        : <button
                            className='clear'
                            onClick={(e) => handleClear(e)}
                        >
                            {`Limpar`}
                        </button>
                    }
                    <button
                        className='save'
                        onClick={(e) => handleSave(e)}
                        disabled={(!enabledBtnSave)}
                    >
                        {`Confirmar`}
                    </button>
                </div>
            </Content>
            {(inProgress) &&
                <InProgress>
                    {(inProgress === 1)
                        ? (
                            <div>
                                <div className='trwDs'>
                                    <div className='loader'></div>
                                </div>
                                <span className='m-b'>
                                    {`Redefinindo senha...`}
                                </span>
                            </div>
                        )
                        : (
                            <div>
                                <img
                                    src={Checked}
                                    alt=""
                                />
                                <span className='m-b'>
                                    {`Sua senha foi redefinida com sucesso !`}
                                </span>
                                <span>
                                    {`Aguarde, você será redirecionado para a tela de login. `}
                                </span>
                            </div>
                        )
                    }
                </InProgress>
            }
        </Container >
    );
}       